"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("g", {
    filter: "url(#a)"
  }, _react.default.createElement("path", {
    d: "m1 23.0001 1.5541-5.647a10.8379 10.8379 0 0 1-1.4617-5.4508c0-6.013 4.916-10.9012 10.9538-10.9012a10.998 10.998 0 0 1 4.1927.8307 10.958 10.958 0 0 1 3.5542 2.365 10.9047 10.9047 0 0 1 2.3744 3.539 10.8635 10.8635 0 0 1 .833 4.1743c-.0026 6.0129-4.917 10.9012-10.9543 10.9012h-.0063a10.9842 10.9842 0 0 1-5.2342-1.327L1 23.0001z",
    fill: "#fff"
  })), _react.default.createElement("path", {
    d: "m1 23 1.5538-5.6481a10.8423 10.8423 0 0 1-1.4624-5.4532C1.0941 5.8878 6.008 1 12.046 1c1.439 0 2.8639.2824 4.1933.8307a10.9587 10.9587 0 0 1 3.5545 2.3652 10.9005 10.9005 0 0 1 2.3741 3.5393A10.8599 10.8599 0 0 1 23 11.9096c0 6.0109-4.9166 10.8998-10.954 10.8998h-.0049a10.9902 10.9902 0 0 1-5.2344-1.3257L1 23z",
    fill: "url(#b)"
  }), _react.default.createElement("g", {
    filter: "url(#c)"
  }, _react.default.createElement("path", {
    d: "m1 23.0001 1.5541-5.647a10.8379 10.8379 0 0 1-1.4617-5.4508c0-6.013 4.916-10.9012 10.9538-10.9012a10.998 10.998 0 0 1 4.1927.8307 10.958 10.958 0 0 1 3.5542 2.365 10.9047 10.9047 0 0 1 2.3744 3.539 10.8635 10.8635 0 0 1 .833 4.1743c-.0026 6.0129-4.917 10.9012-10.9543 10.9012h-.0063a10.9842 10.9842 0 0 1-5.2342-1.327L1 23.0001zm6.0762-3.4896.3324.1966a9.1272 9.1272 0 0 0 4.6339 1.2632h.0037c5.0184 0 9.1024-4.0653 9.1045-9.0612.0009-2.4039-.9575-4.7096-2.6642-6.41-1.7067-1.7005-4.022-2.6564-6.4366-2.6575-5.022 0-9.1061 4.0642-9.1082 9.0602a9.0046 9.0046 0 0 0 1.3918 4.8218l.217.343-.9203 3.3463 3.446-.9024z",
    fill: "url(#d)"
  })), _react.default.createElement("g", {
    filter: "url(#e)"
  }, _react.default.createElement("path", {
    d: "M15.17 13.2951c.251.093 1.5967.7522 1.8704.8886.2736.1364.4501.2028.5205.3168.0704.1139.0704.6597-.1576 1.2958-.2279.6362-1.3225 1.2169-1.8478 1.2948-.4711.0701-1.0678.1014-1.7239-.1077a15.7709 15.7709 0 0 1-1.5605-.575c-2.7444-1.1798-4.538-3.9309-4.6747-4.1128l-.0032-.0043c-.1483-.1974-1.114-1.4832-1.114-2.8137 0-1.3408.707-2 .9576-2.2723a1.0063 1.0063 0 0 1 .3292-.2466 1.011 1.011 0 0 1 .4009-.0947c.1828 0 .3676.002.5252.01.168.0083.3934-.0639.6156.4672.2285.5458.7758 1.8866.8441 2.023.0683.1364.1134.2958.0226.4772-.0909.1814-.1371.2954-.2737.4543-.1366.1589-.2873.3549-.4102.4772-.1371.1375-.2805.2828-.1203.5557.1602.2728.7096 1.1651 1.5232 1.887 1.0458.9284 1.9277 1.2159 2.2013 1.3523.2737.1364.4334.1108.593-.0685.1597-.1793.6844-.7956.8667-1.0679.1822-.2723.3645-.2295.6156-.1364z",
    fill: "#fff"
  })), _react.default.createElement("defs", null, _react.default.createElement("filter", {
    id: "a",
    x: "0",
    y: ".0011",
    width: "24.0005",
    height: "23.999",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), _react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), _react.default.createElement("feOffset", null), _react.default.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), _react.default.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), _react.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), _react.default.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1DropShadow_54390_1137"
  }), _react.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1DropShadow_54390_1137",
    result: "shape"
  })), _react.default.createElement("filter", {
    id: "c",
    x: "0",
    y: ".0011",
    width: "24.0005",
    height: "23.999",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), _react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), _react.default.createElement("feOffset", null), _react.default.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), _react.default.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), _react.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), _react.default.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1DropShadow_54390_1137"
  }), _react.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1DropShadow_54390_1137",
    result: "shape"
  })), _react.default.createElement("filter", {
    id: "e",
    x: "5.4793",
    y: "5.864",
    width: "13.1229",
    height: "12.28",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, _react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), _react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), _react.default.createElement("feOffset", null), _react.default.createElement("feGaussianBlur", {
    stdDeviation: ".5"
  }), _react.default.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), _react.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), _react.default.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1DropShadow_54390_1137"
  }), _react.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1DropShadow_54390_1137",
    result: "shape"
  })), _react.default.createElement("linearGradient", {
    id: "b",
    x1: "11.9997",
    y1: "22.9984",
    x2: "11.9997",
    y2: "1.0022",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#20B038"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#60D66A"
  })), _react.default.createElement("linearGradient", {
    id: "d",
    x1: "12.0005",
    y1: "23.0001",
    x2: "12.0005",
    y2: "1.0001",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#F9F9F9"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })))];
};

exports.default = _default;